module.exports = __webpack_public_path__ + "media/images/catalog-promo/promo265-09adad2ac62a4f8c8781810643e07ed5.jpg";